module.exports = __webpack_public_path__ + "posture/static/img/bottom-bg.679fb8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom-bg.png
// module id = 66wa
// module chunks = 1